import { Link } from 'react-router-dom'
import type { ProductCardData } from '../types/commerce'
import { formatMoney } from '../lib/format'
import { productImageUrl } from '../lib/images'

export function ProductCard({ product }: { product: ProductCardData }) {
  const primary = productImageUrl(product.primary_image_path)
  const secondary = productImageUrl(product.secondary_image_path)
  return (
    <article className="product-card">
      <Link to={`/produto/${product.slug}`} className="product-card__image-wrap">
        {primary ? <img className="product-card__image primary" src={primary} alt={product.name} loading="lazy" /> : <div className="image-placeholder">GK</div>}
        {secondary && <img className="product-card__image secondary" src={secondary} alt="" loading="lazy" />}
        <div className="product-badges">{product.is_new && <span>NOVO</span>}{!product.in_stock && <span>ESGOTADO</span>}</div>
      </Link>
      <div className="product-card__info">
        <Link to={`/produto/${product.slug}`}>{product.name}</Link>
        <div className="price-row">
          {product.sale_price != null ? <><span className="price-old">{formatMoney(product.price)}</span><strong>{formatMoney(product.sale_price)}</strong></> : <strong>{formatMoney(product.price)}</strong>}
        </div>
      </div>
    </article>
  )
}
